import {_, pluralize, classNames, React, useMemo, observer, useLocalStore, useEffect} from '@api'
import {Button, Menu, MenuItem, Popover} from '@blueprintjs/core'
import {Popover2} from '@api'
import {FieldRendererStore, useFieldRendererStore, XRefSidebarFieldStore, XRefSidebarFieldStoreContext} from '@design-board/stores'
import {action, autorun, computed, observable, toJS, trace} from 'mobx'
import * as css from './EnumListRenderer.css'

/// region Store

export class LookupItemListRendererStore {
  constructor(public fieldStore: FieldRendererStore) {
    this.xrefStore = new XRefSidebarFieldStore(fieldStore)
  }

  get catalog() { return this.fieldStore.catalog}

  get strings() { return this.catalog.strings}

  xrefStore: XRefSidebarFieldStore

  @computed get selectedValues() {
    const {fieldStore: {value, field}} = this
    return (_.isArray(value.val) ? value.val : [value.val])?.filter(_.identity) ?? [] as string[]
  }

  @computed get selected() { return new Set<string>(this.selectedValues) }

  @computed get buttonText() {
    const {strings, catalog, xrefStore: {lookupItems}, fieldStore: {value, field, readOnly, catalogField}} = this,
      sortSequence = catalogField?.sort?.custom?._key?.order
    return _.isEmpty(lookupItems)
           ? (value?.valAsString ?? strings.noValue)
           : _.isArray(value?.val) ? sortSequence ? _.orderBy(value?.val, v => sortSequence.indexOf(v)).join(', ') : value.valAsString
                                   : (value?.valAsString || (readOnly ? strings.emptyLabel : `${strings.select} ${field.label ?? catalog.labelForField(catalogField)} ...`))
  }
}

export const LookupItemListRendererStoreContext = React.createContext<LookupItemListRendererStore>(null)

export const LookupItemListRenderer = observer<{ renderAs?: 'popover2' | 'select', className?: string, lookupItems, lookupItemList?: boolean }>(function LookupItemListRenderer({className, renderAs, lookupItems, lookupItemList = true}) {
  const fieldStore = useFieldRendererStore(),
    { field, catalogField, value, updateLookupItems, showPopover, setShowPopover, togglePopover, setShowPopoverOnKeydown, readOnly, editor, itemDetailsStore} = fieldStore,
    store = useLocalStore(() => new LookupItemListRendererStore(fieldStore)),
    {selected, buttonText, selectedValues} = store
  //console.log(toJS({value, buttonText, colorsMap, enumValues, selected, selectedValues}, {recurseEverything: true}))
  return (
    <LookupItemListRendererStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}
           data-selected={value?.valAsString == '' ? 0 : selected.size}
           data-disabled={readOnly}
           data-type='lookupItemList'
      >
        {renderAs === 'select' ? <select></select> :
         <Popover2
           interactionKind='click'
           position='bottom-left'
           popoverClassName={css.popover}
           disabled={readOnly}
           minimal
           onOpened={itemDetailsStore?.freeze}
           onClosed={itemDetailsStore?.unfreeze}
           onInteraction={(popoverState) => !popoverState && setShowPopover(popoverState)}
           isOpen={showPopover}
           content={
             <Menu className={css.menu}>
               {_.isEmpty(lookupItems) ? <MenuItem className={css.enumMenuItem}>No Values</MenuItem>
                                      : lookupItems.map(
                   ({ name, id}, i) => {
                     const /*color = colorsMap.get(name) ?? colorsMap.get(i)*/
                       isSelected = selected.has(name)

                     // console.log({id, name, description, colorsMap, color})
                     return (
                       <MenuItem key={id}
                                 className={css.enumMenuItem}
                                 // data-custom-color={color != null}
                                 // style={color ? {color: color.color, background: color.background} : {}}
                                 icon={isSelected ? 'tick' : 'blank'}
                                 text={name}
                                 shouldDismissPopover={!lookupItemList}
                                 onClick={() => {
                                   const value = name,
                                     values = lookupItemList ? isSelected ? selectedValues.filter(v => v != value) : [...(selectedValues ?? []), value]
                                                       : isSelected ? [] : value
                                   const data = lookupItems.find(v => !_.isArray(values) && v.name === values)
                                   togglePopover()
                                   let element = document.getElementById(catalogField?.field)
                                   element?.focus()
                                   updateLookupItems(field.field, !_.isArray(data) ? data : _.sortBy(data, v => v))
                                 }
                                 }/>)
                   })}
             </Menu>
           }
         >
           <Button id={catalogField?.field}
                   className={css.button}
                   disabled={readOnly}
                   onKeyDown={(e) => {setShowPopoverOnKeydown(e)}}
                   onClick={() => togglePopover()} minimal={editor?.minimal !== false}
                   rightIcon={readOnly ? undefined : 'caret-down'}
                   text={buttonText}
           />
         </Popover2>}
      </div>
    </LookupItemListRendererStoreContext.Provider>)
})



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/LookupItemListRenderer.tsx